// extracted by mini-css-extract-plugin
export default {"container":"Tg-z","copy":"Ug-z","m-heart-activate":"Vg-z","bottomSection":"Wg-z","signInButton":"Xg-z","disabled":"Yg-z","zaprHeart":"Zg-z","m-heart-pulse":"_g-z"};